import axios from '../../_utils/axios';

// ----------------------------------------------------------------------

const deletePotentialGroups = async (groupId) => {
  return await axios.delete(`potential-groups/${groupId}`)
    .catch((error) => {
      return Promise.reject(error);
    });
};

export default deletePotentialGroups;